import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { deviceTokens as endpoint } from '@modules/crm/constants/URL'

// Sem cache via store: a listagem de device tokens é por usuário/sessão e muda a
// cada geração/revogação, então não compensa guardar na memória do Vuex.
class APIDeviceTokens extends APITemplate {
  async listar() {
    return (
      (await con.get(endpoint.list)) ||
      this.buildErrorResponse({ message: 'Erro inesperado' })
    )
  }

  async gerar({ name } = {}) {
    return (
      (await con.post(endpoint.create, { name })) ||
      this.buildErrorResponse({ message: 'Erro inesperado' })
    )
  }

  async revogar({ id } = {}) {
    return (
      (await con.delet(endpoint.delete(id))) ||
      this.buildErrorResponse({ message: 'Erro inesperado' })
    )
  }
}

const apiDeviceTokens = new APIDeviceTokens()
export { apiDeviceTokens }
